/**
 * ISSUE-1361. The tab row of the "who reacted" dialog, built from the
 * per-emoji counts `/message/list` already carries: an `All` tab with the
 * total, then one tab per emoji in the order the bubble draws its chips.
 * The people in each tab come from `/reaction/list`.
 */

export const REACTORS_ALL_TAB = "all";
export const REACTORS_DIALOG_TITLE = "Reactions";
export const REACTORS_ALL_LABEL = "All";
export const REACTORS_SHOW_MORE_LABEL = "Show more";
export const REACTORS_EMPTY = "Nobody has reacted yet.";
export const REACTORS_FAILED = "We could not load who reacted. Try again.";
export const REACTORS_YOU_SUFFIX = "(you)";
export const REACTORS_OPEN_LABEL = "See who reacted";

/** How many people one page of a tab asks for. */
export const REACTORS_PAGE_LIMIT = 30;

export type typeReactorsTab = {
  value: string;
  label: string;
  badge: number;
  /** null on the All tab: no emoji filter is sent. */
  emoji: string | null;
};

export function buildReactorsTabs(
  reactions: readonly { emoji: string; count: number }[],
): typeReactorsTab[] {
  const total = reactions.reduce((sum, reaction) => sum + reaction.count, 0);
  return [
    {
      value: REACTORS_ALL_TAB,
      label: REACTORS_ALL_LABEL,
      badge: total,
      emoji: null,
    },
    ...reactions
      .filter((reaction) => reaction.count > 0)
      .map((reaction) => ({
        value: reaction.emoji,
        label: reaction.emoji,
        badge: reaction.count,
        emoji: reaction.emoji,
      })),
  ];
}

/**
 * The tab to open on: the emoji chip that was clicked when it still has a
 * tab, else All.
 */
export function initialReactorsTab(
  tabs: readonly typeReactorsTab[],
  emoji: string | null,
): string {
  if (emoji === null) return REACTORS_ALL_TAB;
  return tabs.some((tab) => tab.value === emoji) ? emoji : REACTORS_ALL_TAB;
}

/** A reaction chip's accessible name: what it is and that it opens the list. */
export function reactionChipLabel(emoji: string, count: number): string {
  return `${emoji} ${count}, ${REACTORS_OPEN_LABEL.toLowerCase()}`;
}
